var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDiagonalArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0058 1.05C12.0058 0.784784 11.9004 0.530429 11.7129 0.342893C11.5254 0.155357 11.271 0.0500002 11.0058 0.0500002L3.0058 0C2.74058 0 2.48623 0.105357 2.29869 0.292893C2.11116 0.48043 2.0058 0.734784 2.0058 1C2.0058 1.26522 2.11116 1.51957 2.29869 1.70711C2.48623 1.89464 2.74058 2 3.0058 2H8.5658L0.295798 10.29C0.20207 10.383 0.127676 10.4936 0.0769072 10.6154C0.0261385 10.7373 0 10.868 0 11C0 11.132 0.0261385 11.2627 0.0769072 11.3846C0.127676 11.5064 0.20207 11.617 0.295798 11.71C0.388761 11.8037 0.499362 11.8781 0.621222 11.9289C0.743081 11.9797 0.873786 12.0058 1.0058 12.0058C1.13781 12.0058 1.26852 11.9797 1.39038 11.9289C1.51223 11.8781 1.62284 11.8037 1.7158 11.71L10.0058 3.42V9C10.0058 9.26522 10.1112 9.51957 10.2987 9.70711C10.4862 9.89464 10.7406 10 11.0058 10C11.271 10 11.5254 9.89464 11.7129 9.70711C11.9004 9.51957 12.0058 9.26522 12.0058 9V1.05Z",
    fill: "#36B4E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrowRight);
export default __webpack_public_path__ + "static/media/diagonal-arrow-right.5b1a67781683eb3d65bdf21b8a229ff6.svg";
export { ForwardRef as ReactComponent };